
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class GeometricAbstractionEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * (config.parallaxScale || 1.0);

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const s = spacing * 0.8 * (config.parallaxComplexity || 1.0);
                const draw = () => {
                    ctx.strokeRect(x, y, s, s);
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + s, y + s);
                    ctx.moveTo(x + s, y);
                    ctx.lineTo(x, y + s);
                    ctx.stroke();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
